<template>
  <a-modal
    :visible="exportVisible"
    title="导入"
    @cancel="() => (exportVisible = false)"
    :ok-button-props="{
      disabled:
        fileList.length === 0 ||
        searchParams.siteIds.length === 0 ||
        searchParams.terminalIds.length === 0 ||
        !searchParams.moduleType,
      loading: exportLoading
    }"
    :ok-text="'提交'"
    :cancel-text="'取消'"
    @ok="handleExcelSubmit"
  >
    <a-row
      style="margin-bottom: 10px;"
      v-if="
        searchParams.siteIds.length === 0 ||
          searchParams.terminalIds.length === 0 ||
          !searchParams.moduleType
      "
    >
      <a-col :span="24">
        <a-alert
          message="请选择具体的站点、终端、位置进行导入"
          type="warning"
          show-icon
        />
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="20">
        <div style="position: relative;">
          <a-upload
            :file-list="fileList"
            :remove="handleRemove"
            :before-upload="beforeUpload"
            :max-count="1"
            accept=".xls,.xlsx,.csv"
          >
            <a-button><cloud-upload-outlined /> 上传文件 </a-button>
          </a-upload>
          <a-button
            style="position: absolute;top:0;left: 140px"
            type="link"
            @click="downLoadFile"
            >下载模板</a-button
          >
          <div style="color: #b4b4b4;width: 70%">
            支持.xls、.xlsx、.csv格式的文件
          </div>
        </div>
      </a-col>
    </a-row>
  </a-modal>
  <FourElement />
  <div class="collection-container">
    <List />
    <div v-if="dataSource && dataSource.length > 0">
      <div class="fs14 lh30 fl" style="color: #999999;">
        {{
          `共 ${pagination.total} 条记录，第${pagination.pageNum} / ${~~(
            pagination.total / pagination.pageSize
          ) +
            (pagination.total % pagination.pageSize
              ? 1
              : pagination.total === 0
              ? 1
              : 0)}页`
        }}
      </div>
      <div
        style="display: flex; flex-direction: row; float: right; padding-bottom: 50px;"
      >
        <a-pagination
          v-if="pagination.pageSize"
          class="mr20"
          v-model:current="pagination.pageNum"
          :total="pagination.total"
          v-model:pageSize="pagination.pageSize"
          :showTotal="() => false"
          :showSizeChanger="false"
          @change="initList"
        />
        <a-select
          class="mr10"
          style="min-width: 80px;"
          v-model:value="pagination.pageSize"
          @change="initList"
          placeholder="条"
          :options="[
            { value: 10, label: 10 },
            { value: 20, label: 20 },
            { value: 30, label: 30 },
            { value: 40, label: 40 },
            { value: 50, label: 50 }
          ]"
        >
        </a-select>
        <div class="lh30 mr10">条/页</div>
        <div class="lh30 mr10">跳转至</div>
        <a-input-number
          class="mr10"
          style="width: 50px;"
          :value="pagination.pageNum"
          placeholder="页"
          :max="
            pagination.total <= pagination.pageSize
              ? 1
              : Math.ceil(pagination.total / pagination.pageSize)
          "
          :min="1"
          @change="watchPage"
        />
        <div class="lh30">页</div>
      </div>
    </div>
  </div>
  <SideBar />
</template>
<script>
import { toRefs, reactive, provide, onMounted, h } from 'vue'
import FourElement from './components/FourElement'
import SideBar from './components/SideBar'
import List from './components/List'
import useAPI from 'UseApi'
import { message, Modal } from 'ant-design-vue'
import { CloudUploadOutlined } from '@ant-design/icons-vue'
import {
  admin_buyitwith_fix_batch_del_post,
  admin_buyitwith_fix_export_excel_post,
  admin_buyitwith_fix_import_excel_post
} from '@/server/modules/7767_biw.js'
// import { message } from 'ant-design-vue'
const {
  common_querySiteInfo_get_,
  buyitwith_fix_page_post_,
  buyitwith_fix_upsert_get_,
  buyitwith_fix_delete_id_get_
} = useAPI(null, [3426, 4240, 5922, 7595, 4243, 13768])
export default {
  components: {
    FourElement,
    SideBar,
    List,
    CloudUploadOutlined
  },
  setup() {
    const state = reactive({
      exportVisible: false,
      exportLoading: false,
      fileList: [],
      dataSource: [],
      searchParams: {
        terminalIds: [],
        siteIds: [],
        mainSkcs: '',
        moduleType: ''
      },
      sites: [],
      postParams: {
        siteName: null,
        terminalName: null,
        siteIds: [], // 站点ID
        terminalIds: [], // 终端ID
        mainSkc: null, // 主商品SKC
        fixSkcs: [], // 坑位列表
        moduleType: '1'
      },
      categories1: null,
      categories2: null,
      categories3: null,
      categories4: null,
      categories5: null,
      pagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },
      terminalOptions: [
        { value: 1, label: 'WEB' },
        { value: 2, label: 'APP' }
      ],
      moduleTypeOptons: [
        { value: '1', label: 'Buy It With' },
        { value: '2', label: 'You May Also Like' },
        { value: '3', label: 'Similar Items' }
      ],
      moduleTypeObject: {
        1: 'Buy It With',
        2: 'You May Also Like',
        3: 'Similar Items'
      },
      siteBarVisible: false,
      record: null,
      edit: false,

      getDetail: () => {
        const {
          categories1,
          categories2,
          categories3,
          categories4,
          categories5
        } = state
        return [
          { skcCode: categories1, sort: 1 },
          { skcCode: categories2, sort: 2 },
          { skcCode: categories3, sort: 3 },
          { skcCode: categories4, sort: 4 },
          { skcCode: categories5, sort: 5 }
        ]
      },

      modify: edit => {
        let params = { ...state.postParams }
        if (!state.postParams.mainSkc) {
          return message.warning('请输入主商品SKC')
        }
        if (edit) {
          params.id = state.record.id
        }

        params.fixSkcs = state.getDetail()

        buyitwith_fix_upsert_get_(params, state)
      },

      cancel: () => {
        state.siteBarVisible = false
      },

      changeVisible: (record = null) => {
        state.record = record
        state.edit = record ? true : false

        state.siteBarVisible = true

        if (!state.edit) {
          state.postParams = {
            siteName: null,
            terminalName: null,
            siteIds: [], // 站点ID
            terminalIds: [], // 终端ID
            mainSkc: null, // 主商品SKC
            moduleType: '1'
          }
          state.categories1 = null
          state.categories2 = null
          state.categories3 = null
          state.categories4 = null
          state.categories5 = null
        } else {
          state.postParams = {
            siteName: record.siteName,
            terminalName: record.terminalName,
            siteIds: [record.siteId], // 站点ID
            terminalIds: [record.terminalId], // 终端ID
            mainSkc: record.mainSkc, // 主商品SKC
            moduleType: record.moduleType
          }
          record.fixSkcs.map((v, i) => {
            state[`categories${i + 1}`] = v.skcCode
          })
        }
      },

      watchPage: e => {
        state.pagination.pageNum = e
        state.initList()
      },

      deleteFun: params => {
        const { id } = params
        buyitwith_fix_delete_id_get_({ id }, state)
      },

      resetPagination: () => {
        state.pagination = {
          pageNum: 1, // 当前页
          pageSize: 10, // 每页的数量
          total: 0 // 总记录数
        }
        state.initList()
      },
      batchSearchVisible: false,
      batchSearch: () => {
        state.pagination.pageNum = 1
        state.initList()
        state.batchSearchVisible = false
      },
      searchList: () => {
        state.selectedRowKeys = []
        state.pagination.pageNum = 1
        state.initList()
      },
      initList: () => {
        const {
          siteIds,
          terminalIds,
          mainSkcs,
          moduleType
        } = state.searchParams
        let arrMainSkcs = []
        if (mainSkcs) {
          arrMainSkcs = mainSkcs.split(/[\s,，]+/).filter(Boolean)
        }
        let params = {
          query: {
            siteIds,
            terminalIds,
            mainSkcs: arrMainSkcs,
            moduleType
          },
          ...state.pagination
        }
        buyitwith_fix_page_post_(params, state)
      },

      init: () => {
        state.initList()
      },
      selectedRowKeys: [],
      onSelectChange: () => {
        // state.selectedRowKeys = selectedRowKeys
      },
      onRowSelectedAll: selected => {
        let selectedRowKeys = []
        state.dataSource.forEach(item => {
          if (item && item.id) {
            selectedRowKeys.push(item.id)
          }
        })
        if (selected) {
          selectedRowKeys.forEach(item => {
            if (!state.selectedRowKeys.includes(item)) {
              state.selectedRowKeys.push(item)
            }
          })
        } else {
          state.selectedRowKeys = state.selectedRowKeys.filter(
            item => !selectedRowKeys.includes(item)
          )
        }
      },
      onRowSelected: (record, selected) => {
        if (selected) {
          state.selectedRowKeys.push(record.id)
        } else {
          const index = state.selectedRowKeys.indexOf(record.id)
          if (index !== -1) {
            state.selectedRowKeys.splice(index, 1)
          }
        }
      },
      handleBatchDelete: () => {
        Modal.warning({
          title: '确认删除吗？',
          content: '删除后数据将无法恢复，请谨慎操作！',
          onOk() {
            admin_buyitwith_fix_batch_del_post({
              ids: state.selectedRowKeys
            }).then(res => {
              if (res.success) {
                state.selectedRowKeys = []
                state.pagination.pageNum = 1
                state.initList()
              } else {
                message.error(res.message)
              }
            })
          }
        })
      },
      exportExcel: async () => {
        const { success } = await admin_buyitwith_fix_export_excel_post({
          ids: state.selectedRowKeys
        })
        if (success) {
          state.selectedRowKeys = []
          Modal.success({
            title: '导出成功',
            content: h('div', {}, [
              h('p', '导出成功，请前往右上角下载中心下载')
            ])
          })
        }
      },
      downLoadFile: () => {
        const href =
          'https://cdn-image.kapeixi.cn/web/4ad872a1-17ba-4a0e-9d2f-ae297ddaab3c/BIW导入导出模板-20250414.xlsx'
        const archor = document.createElement('a')
        //  将blob实例创建成一个链接
        archor.setAttribute('href', href)
        archor.setAttribute('target', '_blank')
        archor.setAttribute('download', new Date().getTime()) //指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
        document.body.appendChild(archor)
        archor.click()
      },
      handleRemove: file => {
        const index = state.fileList.indexOf(file)
        const newFileList = state.fileList.slice()
        newFileList.splice(index, 1)
        state.fileList = newFileList
      },
      beforeUpload: file => {
        state.fileList = [file]
        return false
      },
      handleExcelSubmit: async () => {
        const { siteIds, terminalIds, moduleType } = state.searchParams
        const {
          success,
          retInfo
        } = await admin_buyitwith_fix_import_excel_post({
          file: state.fileList[0],
          siteIds: siteIds.join(','),
          terminalIds: terminalIds.join(','),
          moduleType
        })
        if (success) {
          message.success('导入成功')
          state.exportVisible = false
          state.fileList = []
          state.pagination.pageNum = 1
          state.initList()
        } else {
          message.error(retInfo)
        }
      }
    })
    onMounted(() => {
      common_querySiteInfo_get_(
        {
          state
        },
        state.init
      )
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
